import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { WorkoutModeService } from '../workoutmode.service';

import { of } from "rxjs";

@Injectable()
export class WorkoutModesAvailableResolver implements Resolve<Observable<string>> {

    constructor(private workoutModesService: WorkoutModeService) { }

    resolve() {
        return this.workoutModesService.getWorkoutModes().catch(() => {
            return of('error');
        });
    }

}

